export const ErrorKeys = {
  // Todo: define Error keys according to error_key field from server
  error_key: "Something went wrong",
};
